import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import Separator from "@material-ui/icons/LinearScale";
import Bullet from "@material-ui/icons/DragIndicator";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";

import servicesStyle from "assets/jss/material-kit-pro-react/views/aboutUsSections/servicesStyle.jsx";

function SectionServices(props) {
  const { classes } = props;
  return (
    <div className={classes.services}>


      <GridContainer>

        <GridItem md={4} sm={4}>
          <InfoArea
            title="Investment Advisory Services."
            description={
              <span>
                <p>
                  Investment Advisory Services team provides a range of services to help our clients determine strategy and execute transactions involving major investment properties.
                </p>

              </span>
            }
            icon={Bullet}
            iconColor="rose"
          />
        </GridItem>

        <GridItem md={4} sm={4}>
          <InfoArea
            title="Metropolitan Investments"
            description={
              <span>
                <p>
                  Specialising in the sale of small to medium sized investments in metropolitan and regional areas throughout Spain, Portugal, LatinAmerica and Europe.
                </p>

              </span>
            }
            icon={Bullet}
            iconColor="rose"
          />
        </GridItem>

        <GridItem md={4} sm={4}>
          <InfoArea
            title="Commercial Property Sales"
            description={
              <span>
                <p>
                  Kinos offer a fully integrated global service combining investment sales, advisory, financing and mortgage banking,
                   together with industry leading research to connect our clients with buyers.

                </p>

              </span>
            }
            icon={Bullet}
            iconColor="rose"
          />
        </GridItem>



      </GridContainer>

      <GridContainer>

        <GridItem md={12} sm={12}
          className={classNames(
            classes.mlAuto,
            classes.mrAuto,
            classes.textCenter
          )}
          >

          <Separator /><Separator /><Separator />
          <h3 className={classes.title}>Institutions we work with</h3>
        </GridItem>

        <GridItem md={6} sm={6}
          className={classNames(
            classes.mlAuto,
            classes.mrAuto,
            classes.textCenter
          )}
          >

            <span>
              <p>
                <h5>Banks</h5>
                <h5>Insurance Companies </h5>
                <h5>Charities</h5>
                <h5>Funds of Hedge Funds</h5>
                <h5>Family Offices</h5>
                <h5>Goverments</h5>
              </p>
            </span>
        </GridItem>



        <GridItem md={6} sm={6}
          className={classNames(
            classes.mlAuto,
            classes.mrAuto,
            classes.textCenter
          )}
          >

            <span>
              <p>
                <h5>Investment Banks</h5> 
                <h5>Pension Fund</h5>
                <h5>Private Equity</h5>
                <h5>SWF ( Sovereign Wealth Funds )</h5> 
                <h5>Socimis ( REIT Funds )</h5> 
                <h5>UHNWI</h5>
              </p> 
            </span>
        </GridItem>

      </GridContainer>
    </div>
  );
}



export default withStyles(servicesStyle)(SectionServices);
